import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

interface SurveyBannerProps {
  markdown: string;
}

export const SurveyBanner: React.FC<SurveyBannerProps> = ({ markdown }) => {
  // Convert ++text++ to <u>text</u> for underline support
  const processedMarkdown = markdown.replace(/\+\+(.+?)\+\+/g, '<u>$1</u>');

  return (
    <div
      style={{
        position: 'relative',
        backgroundColor: '#F7CB67',
        textAlign: 'center',
        zIndex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 60,
        padding: '10px 0',
      }}
    >
      <ReactMarkdown
        rehypePlugins={[rehypeRaw]}
        components={{
          a: ({ children, href = '', ...props }) => {
            // Always open links in a new tab
            if (!href || !href.trim()) {
              return <span>{children}</span>;
            }
            return (
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'blue', textDecoration: 'underline' }}
                {...props}
              >
                {children}
              </a>
            );
          },
          u: ({ node, ...props }) => (
            <u {...props} />
          ),
          p: ({ node, ...props }) => (
            <p style={{ marginBottom: 0 }} {...props} />
          )
        }}
      >
        {processedMarkdown}
      </ReactMarkdown>
    </div>
  );
};
